interface IKeyValuePair<TKey, TValue> {
  key: TKey;
  value: TValue;
}

export class KeyValuePair<TKey, TValue> implements IKeyValuePair<TKey, TValue> {
  key: TKey;
  value: TValue;
}



// WEBPACK FOOTER //
// ./src/app/models/_shared/keyValue.ts